import MainContainer from "../../components/container/MainContainer";

const CreateVendor = () => {
  return <MainContainer>Create Vendor</MainContainer>;
};

export default CreateVendor;
